import { render, staticRenderFns } from "./Contents.vue?vue&type=template&id=1a609842&scoped=true&"
import script from "./Contents.vue?vue&type=script&lang=js&"
export * from "./Contents.vue?vue&type=script&lang=js&"
import style0 from "./Contents.vue?vue&type=style&index=0&id=1a609842&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a609842",
  null
  
)

export default component.exports